import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { DataSourceGrid } from '../../../utils/data-source-grid.component';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as XLSXStyle from 'xlsx-style';
import { Validators } from '@angular/forms';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { modalComponent } from '../../../utils/modal/modal.component';

@Component({
    selector: 'my-estadoResultados-consultar',
    styleUrls: ['estadoResultados-consultar.component.scss'],
    templateUrl: 'estadoResultados-consultar.component.html',
    providers: [generalService]
})
export class EstadoResultadosConsultarComponent implements OnInit{
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  myForm: FormGroup;
  dataSource: DataSourceGrid | MatTableDataSource<any> | null = null;
  @ViewChild('tableEstadoResultados') tableEstadoResultados: ElementRef;
  public dataEstadosResultados: any[] = [];
  public list_Nivel: any[] = [];
  public nivel = 0;
  public fechaExcel;
  public filteredDataNivel: any[] = [];
  public excelData: any[] = [];
  fechaInicioOptions: { id: number, name: string }[] = [];
  displayedColumns = ['NUMEROCUENTA','NOMBRE','ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 
                      'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE','TOTAL'
  ];               
  
  constructor(private formBuilder: FormBuilder,
              private _generalService: generalService,
              public dataService: DataService,
              public dialog: MatDialog) {
              this.myForm = new FormGroup({});
  }
  
  ngOnInit() {
    this.buildForm();
    this.getDataFilters();
    this.populateFechaInicioOptions();
  }
  
  buildForm() {
    const currentYear = new Date().getFullYear();
    this.myForm = this.formBuilder.group({
      nivelForm: ['', Validators.required],
      ejercicio: [currentYear, Validators.required],
    });
  }

  consultar(){
    this.fechaExcel = '';
    this.filteredDataNivel = [];
    this.excelData = [];
    let anio;
    let nivel = this.myForm.controls['nivelForm'].value;
    anio = parseInt(String(this.myForm.get('ejercicio').value).substring(2, 4), 10);
    this.fechaExcel = this.myForm.get('ejercicio').value;
    const params = { 
      anio:anio,
      loacs: sessionStorage.getItem('acslo'),
      nivel:nivel
    };
    this._generalService.metodoCallParams(params, 'EstadoResultados/consultEstadoResultados',true).subscribe(
      (result) => {
        const tableResult = JSON.parse(result);
        if(tableResult.Table != undefined || tableResult.Table != null){
          this.dataEstadosResultados = tableResult.Table;
          const structuredData = this.structureData(this.dataEstadosResultados,nivel);
          this.filteredDataNivel = structuredData;
          // this.dataSource = new DataSourceGrid(this.filteredDataNivel, this.paginator, this.sort);
          this.dataSource = new DataSourceGrid(structuredData, this.paginator, this.sort);
          console.log(structuredData);
        }
        if (this.dataEstadosResultados.length <= 0 || this.dataEstadosResultados.length <= 0) {
          $(".mat-row").remove(".mat-row");
        }          
        
      }, (error) => {
          console.log(error as any);
    });
  }

  structureData(data, nivel) {
    const result = [];

    // Agrupar los datos por RANGE_TYPE_ID
    const groupedByRangeTypeId = data.reduce((acc, item) => {
        const { RANGE_TYPE_ID, RANGE_TYPE_NAME,} = item;
        if (!acc[RANGE_TYPE_ID]) {
            acc[RANGE_TYPE_ID] = { RANGE_TYPE_NAME, items: [] };
        }
        acc[RANGE_TYPE_ID].items.push(item);
        return acc;
    }, {});

    // Iterar sobre cada grupo de RANGE_TYPE_ID
    Object.keys(groupedByRangeTypeId).forEach(rangeTypeId => {
        const rangeType = groupedByRangeTypeId[rangeTypeId];

        // Crear el objeto rangeTypeItem con el nombre del RANGE_TYPE
        const rangeTypeItem = {
            RANGE_TYPE_ID: parseInt(rangeTypeId),
            type: 'RANGE_TYPE',
            name: rangeType.RANGE_TYPE_NAME.toUpperCase(),
            NIVEL: 0
        };

        // Agregar el rangeTypeItem al resultado
        result.push(rangeTypeItem);

        // Agrupar los datos dentro de cada RANGE_TYPE_ID por RANGE_ACCOUNT_ID
        const groupedByRangeAccountId = rangeType.items.reduce((acc, item) => {
            const { RANGE_ACCOUNT_ID, RANGE_ACCOUNT_DESCRIPTION, ENERO, FEBRERO, MARZO, ABRIL, MAYO, JUNIO, JULIO, AGOSTO, SEPTIEMBRE, OCTUBRE, NOVIEMBRE, DICIEMBRE } = item;
            if (!acc[RANGE_ACCOUNT_ID]) {
                acc[RANGE_ACCOUNT_ID] = {
                    RANGE_ACCOUNT_DESCRIPTION,
                    items: [],
                    totalENERO: 0,
                    totalFEBRERO: 0,
                    totalMARZO: 0,
                    totalABRIL: 0,
                    totalMAYO: 0,
                    totalJUNIO: 0,
                    totalJULIO: 0,
                    totalAGOSTO: 0,
                    totalSEPTIEMBRE: 0,
                    totalOCTUBRE: 0,
                    totalNOVIEMBRE: 0,
                    totalDICIEMBRE: 0,
                    totalMeses_RANGE_ACCOUNT: 0
                };
            }
            acc[RANGE_ACCOUNT_ID].items.push(item);
            acc[RANGE_ACCOUNT_ID].totalENERO += ENERO;
            acc[RANGE_ACCOUNT_ID].totalFEBRERO += FEBRERO;
            acc[RANGE_ACCOUNT_ID].totalMARZO += MARZO;
            acc[RANGE_ACCOUNT_ID].totalABRIL += ABRIL;
            acc[RANGE_ACCOUNT_ID].totalMAYO += MAYO;
            acc[RANGE_ACCOUNT_ID].totalJUNIO += JUNIO;
            acc[RANGE_ACCOUNT_ID].totalJULIO += JULIO;
            acc[RANGE_ACCOUNT_ID].totalAGOSTO += AGOSTO;
            acc[RANGE_ACCOUNT_ID].totalSEPTIEMBRE += SEPTIEMBRE;
            acc[RANGE_ACCOUNT_ID].totalOCTUBRE += OCTUBRE;
            acc[RANGE_ACCOUNT_ID].totalNOVIEMBRE += NOVIEMBRE;
            acc[RANGE_ACCOUNT_ID].totalDICIEMBRE += DICIEMBRE;
            acc[RANGE_ACCOUNT_ID].totalMeses_RANGE_ACCOUNT += ENERO + FEBRERO + MARZO + ABRIL + MAYO + JUNIO + JULIO + AGOSTO + SEPTIEMBRE + OCTUBRE + NOVIEMBRE + DICIEMBRE;
            return acc;
        }, {});

        // Inicializar el total de todos los meses para el RANGE_TYPE
        let totalENERO_RANGE_TYPE = 0;
        let totalFEBRERO_RANGE_TYPE = 0;
        let totalMARZO_RANGE_TYPE = 0;
        let totalABRIL_RANGE_TYPE = 0;
        let totalMAYO_RANGE_TYPE = 0;
        let totalJUNIO_RANGE_TYPE = 0;
        let totalJULIO_RANGE_TYPE = 0;
        let totalAGOSTO_RANGE_TYPE = 0;
        let totalSEPTIEMBRE_RANGE_TYPE = 0;
        let totalOCTUBRE_RANGE_TYPE = 0;
        let totalNOVIEMBRE_RANGE_TYPE = 0;
        let totalDICIEMBRE_RANGE_TYPE = 0;
        let totalMeses_RANGE_TYPE = 0;

        // Agregar los RANGE_ACCOUNT al resultado y sumar los saldos iniciales al RANGE_TYPE
        Object.keys(groupedByRangeAccountId).forEach(rangeAccountId => {
            const rangeAccount = groupedByRangeAccountId[rangeAccountId];

            // Crear el objeto rangeAccountItem con la descripción del RANGE_ACCOUNT
            const rangeAccountItem = {
                RANGE_TYPE_ID: parseInt(rangeTypeId),
                RANGE_ACCOUNT_ID: parseInt(rangeAccountId),
                RANGE_ACCOUNT_ID_index: parseInt(rangeAccountId),
                type: 'RANGE_ACCOUNT',
                name: rangeAccount.RANGE_ACCOUNT_DESCRIPTION,
                NIVEL: 0,
                totalENERO: rangeAccount.totalENERO,
                totalFEBRERO: rangeAccount.totalFEBRERO,
                totalMARZO: rangeAccount.totalMARZO,
                totalABRIL: rangeAccount.totalABRIL,
                totalMAYO: rangeAccount.totalMAYO,
                totalJUNIO: rangeAccount.totalJUNIO,
                totalJULIO: rangeAccount.totalJULIO,
                totalAGOSTO: rangeAccount.totalAGOSTO,
                totalSEPTIEMBRE: rangeAccount.totalSEPTIEMBRE,
                totalOCTUBRE: rangeAccount.totalOCTUBRE,
                totalNOVIEMBRE: rangeAccount.totalNOVIEMBRE,
                totalDICIEMBRE: rangeAccount.totalDICIEMBRE,
                totalMeses: rangeAccount.totalMeses_RANGE_ACCOUNT
            };

            result.push(rangeAccountItem); // Añadir rangeAccountItem al principio

            // Agregar las filas de datos regulares debajo del RANGE_ACCOUNT si hay datos
            if (rangeAccount.items.length > 0) {
                result.push(...rangeAccount.items);
            }

            // Añadir el total como un nuevo objeto al final del grupo
            const totalAccountItem = {
              RANGE_TYPE_ID: parseInt(rangeTypeId),
              RANGE_ACCOUNT_ID: parseInt(rangeAccountId),
              type: 'Total_RANGE_ACCOUNT',
              nameTotal: 'Total ' + rangeAccount.RANGE_ACCOUNT_DESCRIPTION,
              NIVEL: 0,
              NUMBER: '',
              NAME: '',
              totalENERO_RANGE_ACCOUNT: rangeAccount.totalENERO,
              totalFEBRERO_RANGE_ACCOUNT: rangeAccount.totalFEBRERO,
              totalMARZO_RANGE_ACCOUNT: rangeAccount.totalMARZO,
              totalABRIL_RANGE_ACCOUNT: rangeAccount.totalABRIL,
              totalMAYO_RANGE_ACCOUNT: rangeAccount.totalMAYO,
              totalJUNIO_RANGE_ACCOUNT: rangeAccount.totalJUNIO,
              totalJULIO_RANGE_ACCOUNT: rangeAccount.totalJULIO,
              totalAGOSTO_RANGE_ACCOUNT: rangeAccount.totalAGOSTO,
              totalSEPTIEMBRE_RANGE_ACCOUNT: rangeAccount.totalSEPTIEMBRE,
              totalOCTUBRE_RANGE_ACCOUNT: rangeAccount.totalOCTUBRE,
              totalNOVIEMBRE_RANGE_ACCOUNT: rangeAccount.totalNOVIEMBRE,
              totalDICIEMBRE_RANGE_ACCOUNT: rangeAccount.totalDICIEMBRE,
              totalMeses_RANGE_ACCOUNT: rangeAccount.totalMeses_RANGE_ACCOUNT
            };

            result.push(totalAccountItem); // Añadir totalAccountItem al final del grupo

            // Sumar al total de todos los meses para el RANGE_TYPE
            totalENERO_RANGE_TYPE += rangeAccount.totalENERO;
            totalFEBRERO_RANGE_TYPE += rangeAccount.totalFEBRERO;
            totalMARZO_RANGE_TYPE += rangeAccount.totalMARZO;
            totalABRIL_RANGE_TYPE += rangeAccount.totalABRIL;
            totalMAYO_RANGE_TYPE += rangeAccount.totalMAYO;
            totalJUNIO_RANGE_TYPE += rangeAccount.totalJUNIO;
            totalJULIO_RANGE_TYPE += rangeAccount.totalJULIO;
            totalAGOSTO_RANGE_TYPE += rangeAccount.totalAGOSTO;
            totalSEPTIEMBRE_RANGE_TYPE += rangeAccount.totalSEPTIEMBRE;
            totalOCTUBRE_RANGE_TYPE += rangeAccount.totalOCTUBRE;
            totalNOVIEMBRE_RANGE_TYPE += rangeAccount.totalNOVIEMBRE;
            totalDICIEMBRE_RANGE_TYPE += rangeAccount.totalDICIEMBRE;
            totalMeses_RANGE_TYPE += rangeAccount.totalMeses_RANGE_ACCOUNT;
        });

        // Añadir el total del RANGE_TYPE como un nuevo objeto al final del grupo
        const totalRangeTypeItem = {
          RANGE_TYPE_ID: parseInt(rangeTypeId),
          type: 'Total_RANGE_TYPE',
          nameTotal: 'Total ' + rangeType.RANGE_TYPE_NAME.toUpperCase(),
          NIVEL: 0,
          NUMBER: '',
          NAME: '',
          totalENERO_RANGE_TYPE: totalENERO_RANGE_TYPE,
          totalFEBRERO_RANGE_TYPE: totalFEBRERO_RANGE_TYPE,
          totalMARZO_RANGE_TYPE: totalMARZO_RANGE_TYPE,
          totalABRIL_RANGE_TYPE: totalABRIL_RANGE_TYPE,
          totalMAYO_RANGE_TYPE: totalMAYO_RANGE_TYPE,
          totalJUNIO_RANGE_TYPE: totalJUNIO_RANGE_TYPE,
          totalJULIO_RANGE_TYPE: totalJULIO_RANGE_TYPE,
          totalAGOSTO_RANGE_TYPE: totalAGOSTO_RANGE_TYPE,
          totalSEPTIEMBRE_RANGE_TYPE: totalSEPTIEMBRE_RANGE_TYPE,
          totalOCTUBRE_RANGE_TYPE: totalOCTUBRE_RANGE_TYPE,
          totalNOVIEMBRE_RANGE_TYPE: totalNOVIEMBRE_RANGE_TYPE,
          totalDICIEMBRE_RANGE_TYPE: totalDICIEMBRE_RANGE_TYPE,
          totalMeses_RANGE_TYPE: totalMeses_RANGE_TYPE
        };

        result.push(totalRangeTypeItem); // Añadir totalRangeTypeItem al final del grupo
    });

    return result;
  }


  getDataFilters() {
    this.list_Nivel= [];
    let metodo = 'EstadoResultados/getLevel';
    const params = { 
        loacs: sessionStorage.getItem('acslo'),
    };

    this._generalService.metodoCallParams(params, metodo, true).subscribe(
      result => {
        const tableResult = JSON.parse(result);
        this.nivel = tableResult.Table[0]['LEVEL'];
        for(let i = this.nivel; i >= 1; i--){
          this.list_Nivel.push({
            nivel: i,
            NAME: i
          });
        }
        this.myForm.get('nivelForm').setValue(this.list_Nivel[0]['nivel']);
        this.consultar();
      },
      error => {  console.log(<any>error);  }
    );
  }

  populateFechaInicioOptions() {
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= currentYear - 3; year--) {
      this.fechaInicioOptions.push({ id: year, name: year.toString() });
    }
  }
  
  exportarExcel() {
    if (this.dataEstadosResultados.length > 0) {
      this.readyExport();
    }
  }

  readyExport() {
    let fecha = ''; 
    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    const currentDate = new Date();
    const currentMonthIndex = currentDate.getMonth();
    const currentMonthName = monthNames[currentMonthIndex];
    fecha = currentMonthName +' '+ this.fechaExcel
    setTimeout(() => this.exportAsExcelFile("Estado de Resultados " + fecha), 500);
  }

  exportAsExcelFile(filename: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.tableEstadoResultados.nativeElement);
    const headersWorksheet = ['NÚMERO DE CUENTA', 'NOMBRE', 'ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 
                              'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE', 'TOTAL'];
  
    for (const z in worksheet) {
      if (z[0] === '!') continue; 
  
      const cell = worksheet[z];
      if (cell) {
        const col = z.replace(/[0-9]/g, ''); 
        const cellValue = cell.v;
  
        let cellStyle: any = { alignment: { vertical: 'center', horizontal: 'center' } }; 
  
        if (headersWorksheet.indexOf(cellValue + '') > -1) {
          cellStyle.font = { bold: true }; 
          cellStyle.numFmt = '@'; // Texto para los encabezados
        } else if (col === 'O') {
          cellStyle.numFmt = '$#,##0.00'; // Asegura formato de moneda para la columna 'O'
          if (typeof cellValue === 'number' && cellValue < 0) {
            cellStyle.font = { color: { rgb: 'FF0000' } }; // Rojo para valores negativos en la última columna
          }
        } else if (typeof cellValue === 'number') {
          cellStyle.numFmt = '$#,##0.00'; // Formato de decimal para otras celdas numéricas
          if (cellValue < 0) {
            cellStyle.font = { color: { rgb: 'FF0000' } }; // Rojo para valores negativos
          }
        } else if (typeof cellValue === 'string' && cellValue.startsWith('$')) {
          cellStyle.numFmt = '$#,##0.00'; // Formato de decimal para celdas con '$'
        } else {
          cellStyle.numFmt = '@'; // Texto por defecto
        }
  
        // Aplica el estilo a la celda
        this.setCellStyle(cell, cellStyle); 
      }
    }
  
    const workbook: XLSX.WorkBook = { Sheets: { General: worksheet }, SheetNames: ['General'] };
    const excelBuffer: any = XLSXStyle.write(workbook, { bookType: 'xlsx', type: 'buffer' });
  
    this.saveAsExcelFile(excelBuffer, filename);
  }
  
  saveAsExcelFile(buffer: any, filename: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    FileSaver.saveAs(data, filename + '.xlsx');
  }
  
  wrapAndCenterCell(cell: XLSX.CellObject, tipo: string) {
    let cellStyle: any = { alignment: { vertical: 'center', horizontal: 'center' } }; 
  
    switch (tipo) {
      case 'header':
        cellStyle.font = { bold: true }; 
        cellStyle.numFmt = '@'; // Texto para los encabezados
        break;
      case 'decimal':
        cellStyle.numFmt = '$#,##0.00'; 
        if (typeof cell.v === 'number' && cell.v < 0) {
          cellStyle.font = { color: { rgb: 'FF0000' } }; // Poner en rojo los valores negativos
        }
        break;
      case 'porcentaje':
        cellStyle.numFmt = '0.00%;\\(0.00%\\);\\-;@'; 
        break;
    }
  
    this.setCellStyle(cell, cellStyle); 
  }
  
  setCellStyle(cell: XLSX.CellObject, style: any) {
    cell.s = style;
  }
  
    
}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/estadoResultados/consultar/estadoResultados-consultar.component.ts